import React, { useRef, useState } from "react";
import { supabase } from "../lib/supabaseClient";

export default function EmailSignup({ 
  title = "Every Story Deserves a Voice.", 
  subtitle = "",
  buttonText = "Join Waitlist",
  successMessage = "Thanks for joining! We'll be in touch soon.",
  showSuccessRedirect = false,
  onSuccess = null 
}) {
  const emailInputRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    const email = emailInputRef.current.value.trim();
    
    if (!email) {
      setStatus("Please enter your email address.");
      return;
    }
    
    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setStatus("Please enter a valid email address.");
      return;
    }
    
    setIsSubmitting(true);
    setStatus("Joining waitlist...");
    
    try {
      // Store email in database
      const { data, error } = await supabase
        .from("email_signups")
        .insert([{
          email: email,
          source: window.location.pathname,
          user_agent: navigator.userAgent,
          referrer: document.referrer || null
        }]);
      
      if (error) {
        console.error('❌ [EMAIL SIGNUP] Database error:', error);
        
        // Check if it's a duplicate email error
        if (error.code === '23505' || error.message.includes('duplicate') || error.message.includes('already exists')) {
          setStatus("You're already on our waitlist! We'll be in touch soon.");
        } else {
          setStatus("Something went wrong. Please try again.");
        }
        setIsSubmitting(false);
        return;
      }
      
      console.log('✅ [EMAIL SIGNUP] Successfully stored email:', email);
      setStatus(successMessage);
      emailInputRef.current.value = "";
      
      // Call custom success callback if provided
      if (onSuccess) {
        onSuccess(email, data);
      }
      
      // Optional redirect after success
      if (showSuccessRedirect) {
        setTimeout(() => {
          window.location.href = '/about';
        }, 2000);
      }
      
    } catch (error) {
      console.error('❌ [EMAIL SIGNUP] Unexpected error:', error);
      setStatus("Something went wrong. Please try again.");
    }
    
    setIsSubmitting(false);
  }

  return (
    <main className="hero">
      <h1 className="hero-title">
        {title.includes('span') ? (
          <span dangerouslySetInnerHTML={{ __html: title }} />
        ) : (
          title
        )}
      </h1>
      {subtitle && (
        <p className="hero-desc serif">
          {subtitle}
        </p>
      )}
      <form className="hero-actions" onSubmit={handleSubmit}>
        <div className="hero-input-wrapper">
          <input
            placeholder="Enter your email"
            className="hero-input"
            type="email"
            ref={emailInputRef}
            disabled={isSubmitting}
            required
            style={{ 
              background: '#fff',
              cursor: isSubmitting ? 'not-allowed' : 'text'
            }}
          />
        </div>
        <button
          type="submit"
          className="hero-btn"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Joining..." : buttonText}
        </button>
      </form>
      {status && (
        <div 
          className="text-sm mt-2 mb-4" 
          style={{ 
            color: status.includes('wrong') || status.includes('valid') ? 'red' : 
                   status.includes('Thanks') || status.includes('already') ? 'green' : 
                   '#666'
          }}
        >
          {status}
        </div>
      )}
    </main>
  );
}